import swal from 'sweetalert2';

import VSRelatedQuestion from './vs-related-question';

import loginController from '@/scripts/libs/login/controller';
import webcall from '@/scripts/webcall';

const _question = {
  id: '',
};

const _preInit = function _preInit() {
  return ($('#question').length !== 0);
};

const _getProp = (element, property, shouldDelete = true) => {
  const value = element.getAttribute(property);
  if (shouldDelete) element.removeAttribute(property);
  return value;
};

const _initPageData = function _initPageData() {
  const $question = document.getElementById('question');
  _question.id = parseInt(_getProp($question, 'data-question-id', false));
  _question.userid = parseInt(_getProp($question, 'data-question-user-id'));
};

const _authorMethods = {
  edit() {
    window.location = window.location.pathname + '/edit';
  },
  delete() {
    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true,

      buttonsStyling: false,
      cancelButtonClass: 'btn btn-outline-secondary',
      confirmButtonClass: 'btn btn-primary',

      animation: false,
      preConfirm: async() => {
        swal.getCancelButton().disabled = true;
        swal.getConfirmButton().disabled = true;

        try {
          await webcall.community.deleteQuestion({
            question_id: _question.id,
          });
        } finally {
          swal.getCancelButton().disabled = false;
          swal.getConfirmButton().disabled = false;
        }
      },
      allowOutsideClick: true,
      focusConfirm: false,
      focusCancel: true,
    })
      .then(() => {
        swal({
          title: 'Deleted!',
          text: 'The post has been deleted.',
          type: 'success',

          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary',
        });
        // Redirect user to community
        window.location = '/community';
      });
  },
};

/**
 * Check if the user has permission to access the authoring tool of this question
 * @param {Object} user
 * @param {String} questionUserId
 * @returns {Boolean}
 */
const _getAuthorAccess = function _getAuthorAccess(user, questionUserId) {
  if (!user) return false;

  // Return true if user is either owner or admin
  return (
    (questionUserId === user.id) || // Is owner
    (user.adminAccess) // Is admin
  );
};

const _initPostAuthorTool = function _initPostAuthorTool() {
  const methodIdentifier = 'data-v-method';
  const authorToolNodeList = document.querySelectorAll(`[${methodIdentifier}]`);
  const authorTools = [...authorToolNodeList];

  loginController.getUser()
    .then((user) => {
      authorTools.forEach((element) => {
      // Remove authoring element if the user has no access
        if (!_getAuthorAccess(user, _question.userid)) return element.parentElement.removeChild(element);

        // Otherwise
        const methodName = _getProp(element, methodIdentifier);
        const method = _authorMethods[methodName];
        if (!method) return element.parentElement.removeChild(element);

        // Show author tool
        element.classList.remove('d-none');
        element.addEventListener('click', method);
      });
    });
};

const VSCommunityQuestion = {
  init() {
    if (!_preInit()) {
      return;
    }

    _initPageData();
    _initPostAuthorTool();

    VSRelatedQuestion.init();
  },
};

export default VSCommunityQuestion;
